/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { shareContent } from "./ShareUtils"; // Import the share function

const FooterV3 = () => {
  const handleShareClick = () => {
    shareContent().catch((error) => {
      // Handle errors or provide a fallback experience
      console.error("Share failed:", error);
    });
  };
  return (
    <div>
      <footer class="mt-auto w-full max-w-[85rem] py-10 px-4 sm:px-6 lg:px-8 mx-auto">
        <div class="text-center">
          <div class="mt-3">
            <p class="text-gray-100">© Studio3 Fitness. All rights reserved.</p>
          </div>

          <div className="space-x-6 mt-4">
            <button
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://www.facebook.com/studio3LQA/"
              target="_blank"
              rel="noreferrer"
              onClick={handleShareClick}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
                />
              </svg>
            </button>
            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://www.facebook.com/studio3LQA/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
              </svg>
            </a>
            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://www.instagram.com/studio3.fit/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 552 552"
                fill="none"
              >
                <g clip-path="url(#clip0_217_30)">
                  <path
                    d="M386.878 0H164.156C73.64 0 0 73.64 0 164.156V386.878C0 477.394 73.64 551.034 164.156 551.034H386.878C477.394 551.034 551.034 477.394 551.034 386.878V164.156C551.033 73.64 477.393 0 386.878 0ZM495.6 386.878C495.6 446.923 446.923 495.6 386.878 495.6H164.156C104.111 495.6 55.434 446.923 55.434 386.878V164.156C55.434 104.11 104.111 55.434 164.156 55.434H386.878C446.923 55.434 495.6 104.11 495.6 164.156V386.878Z"
                    fill="white"
                  />
                  <path
                    d="M275.517 133C196.933 133 133 196.933 133 275.516C133 354.099 196.933 418.033 275.517 418.033C354.101 418.033 418.034 354.1 418.034 275.516C418.034 196.932 354.101 133 275.517 133ZM275.517 362.6C227.422 362.6 188.434 323.612 188.434 275.517C188.434 227.422 227.423 188.434 275.517 188.434C323.612 188.434 362.6 227.422 362.6 275.517C362.6 323.611 323.611 362.6 275.517 362.6Z"
                    fill="white"
                  />
                  <path
                    d="M418.31 168.22C437.171 168.22 452.46 152.93 452.46 134.07C452.46 115.209 437.171 99.9199 418.31 99.9199C399.45 99.9199 384.16 115.209 384.16 134.07C384.16 152.93 399.45 168.22 418.31 168.22Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_217_30">
                    <rect width="551.034" height="551.034" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://goo.gl/maps/EEhsQzDANvyTc7Mw7"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
              </svg>
            </a>
            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://twitter.com/Studio3Fitness"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
              </svg>
            </a>

            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://www.yelp.com/biz/studio-3-fit-seattle"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 436 436"
                fill="none"
              >
                <g clip-path="url(#clip0_216_4)">
                  <path
                    d="M182.47 306.937L122.235 380.288C113.76 390.608 117.809 406.193 130.235 411.084L189.124 434.262C201.828 439.262 215.638 430.121 215.999 416.473L218.538 320.39C219.05 301.021 194.766 291.964 182.47 306.937Z"
                    fill="white"
                  />
                  <path
                    d="M172.459 234.018L83.1281 201.945C70.5591 197.432 57.2421 206.484 56.8131 219.832L54.7801 283.085C54.3411 296.731 67.5931 306.665 80.5681 302.416L171.913 272.509C190.327 266.481 190.694 240.565 172.459 234.018Z"
                    fill="white"
                  />
                  <path
                    d="M274.839 244.311L366.341 219.091C379.215 215.543 384.89 200.474 377.555 189.314L342.793 136.431C335.294 125.023 318.739 124.532 310.578 135.477L253.12 212.529C241.537 228.061 256.161 249.46 274.839 244.311Z"
                    fill="white"
                  />
                  <path
                    d="M208.574 24.4307C209.302 8.60468 194.389 -3.33432 179.105 0.839683L106.677 20.6197C91.0521 24.8867 84.4161 43.3807 93.7631 56.6087L176.879 200.607C177.554 201.776 178.298 202.909 179.173 203.938C191.482 218.403 214.59 213.043 220.286 196.11C221.309 193.068 221.597 189.826 221.345 186.626L208.574 24.4307Z"
                    fill="white"
                  />
                  <path
                    d="M366.966 310.135L275.083 281.922C256.562 276.235 241.324 297.201 252.452 313.062L306.963 390.762C314.632 401.694 330.733 401.973 338.776 391.313L376.896 340.797C385.12 329.899 380.017 314.143 366.966 310.135Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_216_4">
                    <rect width="435.646" height="435.646" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              className="inline-flex justify-center items-center gap-x-3.5 w-4 h-4 text-center text-gray-200 hover:bg-white/[.1] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-gray-900 transition"
              href="https://www.yelp.com/biz/studio-3-fit-seattle"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                className="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                width="1001"
                height="357"
                viewBox="0 0 1001 357"
                fill="none"
              >
                <path
                  d="M110.784 356.845C80.9877 355.662 56.6102 347.508 37.549 332.366C33.9112 329.473 25.2429 320.799 22.3347 317.141C14.6051 307.422 9.35004 297.963 5.84494 287.468C-4.94076 255.162 0.610256 212.769 21.7225 166.243C39.799 126.412 67.6918 86.9068 116.355 32.1926C123.523 24.1415 144.87 0.595703 145.008 0.595703C145.059 0.595703 143.896 2.61099 142.431 5.06509C129.778 26.2589 118.952 51.2231 113.054 72.8354C103.58 107.514 104.722 137.274 116.401 160.35C124.457 176.248 138.268 190.019 153.799 197.631C180.988 210.953 220.794 212.055 269.406 200.856C272.753 200.08 438.599 156.055 637.956 103.019C837.313 49.9782 1000.45 6.61609 1000.48 6.65179C1000.53 6.69779 537.314 204.912 296.85 307.743C258.768 324.024 248.584 328.136 230.681 334.422C184.916 350.493 143.921 358.162 110.784 356.845Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterV3;
